import { baseApi } from 'shared/api'

export const walletApi = baseApi.injectEndpoints({
  endpoints: build => ({
    walletAddress: build.query<any, void>({
      query: ({ leadId, ...params }) => ({
        url: `/wallets/${leadId}/wallet`,
        params,
      }),
    }),
    walletCurrency: build.query<any, void>({
      query: ({ leadId, ...params }) => ({
        url: `/wallets/${leadId}/wallet/currency`,
        params,
      }),
    }),
  }),
})

export const { useWalletAddressQuery, useWalletCurrencyQuery } = walletApi
